/**
 * Header JavaScript for Amazon Marketing Theme
 * 
 * Handles sticky header functionality and mobile menu interactions
 */

(function() {
  // Initialize header functionality when DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    initStickyHeader();
    initMobileMenu();
    initSearchModal();
  });

  /**
   * Initialize sticky header functionality
   */
  function initStickyHeader() {
    const header = document.querySelector('.site-header.sticky');
    
    if (!header) return;
    
    // Force the header to be sticky
    header.style.position = 'sticky';
    header.style.top = '0';
    header.style.zIndex = '9999';
    
    // Add box shadow on scroll
    function handleScroll() {
      if (window.scrollY > 10) {
        header.style.boxShadow = '0 2px 10px rgba(0, 0, 0, 0.1)';
      } else {
        header.style.boxShadow = 'none';
      }
    }
    
    // Add scroll event listener
    window.addEventListener('scroll', handleScroll);
    
    // Initial check on page load
    handleScroll();
  }

  /**
   * Initialize mobile menu functionality
   */
  function initMobileMenu() {
    const mobileToggle = document.querySelector('.header-mobile-toggle__button');
    const mobileMenu = document.querySelector('.mobile-menu');
    const mobileMenuClose = document.querySelector('.mobile-menu__close');
    const submenuToggles = document.querySelectorAll('.mobile-menu__toggle');
    
    if (mobileToggle && mobileMenu) {
      // Toggle mobile menu
      mobileToggle.addEventListener('click', function() {
        mobileMenu.classList.add('active');
        document.body.classList.add('mobile-menu-open');
        document.body.style.overflow = 'hidden';
      });
      
      // Close mobile menu
      mobileMenuClose.addEventListener('click', function() {
        mobileMenu.classList.remove('active');
        document.body.classList.remove('mobile-menu-open');
        document.body.style.overflow = '';
      });
      
      // Close mobile menu when clicking outside
      document.addEventListener('click', function(e) {
        if (mobileMenu.classList.contains('active') && 
            !mobileMenu.contains(e.target) && 
            !mobileToggle.contains(e.target)) {
          mobileMenu.classList.remove('active');
          document.body.classList.remove('mobile-menu-open');
          document.body.style.overflow = '';
        }
      });
      
      // Handle submenu toggles
      submenuToggles.forEach(function(toggle) {
        toggle.addEventListener('click', function() {
          const submenu = this.closest('.mobile-menu__item').querySelector('.mobile-submenu');
          this.classList.toggle('active');
          submenu.classList.toggle('active');
        });
      });
    }
  }

  /**
   * Initialize search modal functionality
   */
  function initSearchModal() {
    const searchToggle = document.querySelector('.header-search__toggle');
    const searchModal = document.querySelector('.search-modal');
    const searchModalClose = document.querySelector('.search-modal__close');
    
    if (searchToggle && searchModal) {
      // Open search modal
      searchToggle.addEventListener('click', function() {
        searchModal.classList.add('active');
        document.body.style.overflow = 'hidden';
        searchModal.querySelector('.search-form__input').focus();
      });
      
      // Close search modal
      searchModalClose.addEventListener('click', function() {
        searchModal.classList.remove('active');
        document.body.style.overflow = '';
      });
      
      // Close search modal when clicking outside
      searchModal.addEventListener('click', function(e) {
        if (e.target === searchModal) {
          searchModal.classList.remove('active');
          document.body.style.overflow = '';
        }
      });
    }
  }
})();
